import { lazy } from 'react';

// Buying journey – real pages only (legacy PO detail lazy stubs removed)
export const OrderDetails = lazy(() => import('pages/BuyingJourneyPages/OrderDetails'));
export const MediaPIList = lazy(() => import('pages/BuyingJourneyPages/MediaPIList'));
export const SellerMediapiList = lazy(() => import('pages/BuyingJourneyPages/SellerMediaPIList'));
